/**
 * On-page-style filters
 */

// hide items
const hideItems = (speed, containerEl) => {
	return new Promise((resolve) => {
		const items = [...containerEl.children];
		if (items.length) {
			items.forEach((item) => {
				item.classList.add('unloading');
			});
			setTimeout(() => {
				resolve();
			}, speed);
		} else {
			resolve();
		}
	});
};

// show items
const showItems = (html, containerEl) => {
	if (html && html.substring(0, 2) === '"<') {
		/* TEMP */
		// console.error('⛔️ using dev mode urls');
		// html = html.replaceAll(
		// 	'norris-design.aquamarine.test',
		// 	window.location.host
		// );
		/* TEMP */
		const parser = new DOMParser();
		const doc = parser.parseFromString(JSON.parse(html), 'text/html');
		containerEl.innerHTML = doc.body.innerHTML;
	} else {
		console.error('Error fetching posts', html);
	}
};

export const fetchItems = async ({ postType, filters, containerEl }) => {
	await hideItems(150, containerEl);
	const apiBase = aquaminLocalizedScripts.restUrl;
	const apiEndpoint = `/aquamin/v1/filter/`;
	let apiQuery = `post_type=${postType}`;
	if (filters) {
		Object.keys(filters).forEach((filter) => {
			if (filters[filter].length) {
				// eslint-disable-next-line prettier/prettier
				apiQuery = `${apiQuery}&tax[${filter}]=${filters[filter].join(',')}`;
			}
		});
	}
	const apiCall = `${apiBase}${apiEndpoint}?${apiQuery}`;
	fetch(apiCall)
		.then((response) => response.text())
		.then((html) => {
			showItems(html, containerEl);
		});
};

// /* DEBUG */ setTimeout(() => {
// 	document.querySelector('.filter__trigger').click();
// 	document.querySelectorAll('.filter__box')?.[2]?.click();
// 	setTimeout(() => {
// 		console.clear();
// 		document.querySelectorAll('.filter__box')[5].click();
// 	}, 1500);
// }, 500);
